import { getCoacheeStatus, assignCoachCoachee, saveNote, getIndividualCoacheeStatus, getCoacheesCareerIdeas, getNote } from '../api'
import { getAdvisees } from '../../adviseeTracker/api'

export const loadCoacheeStatus = ({ state, commit }) => {
  return getCoacheeStatus().then(data => {
    return data
  })
}

export const loadIndividualCoacheeStatus = ({ state, commit }) => {
  return getIndividualCoacheeStatus().then(data => {
    return data
  })
}

export const loadCoachees = ({ state, commit }, {name}) => {
  let page = 0
  let count = 100
  return getAdvisees(page, count, name).then(data => {
    return data
  })
}

export const loadCoacheesCareerIdeas = ({ state, commit }) => {
  return getCoacheesCareerIdeas().then(data => {
    return data
  })
}

export const loadAssignCoachCoachee = ({ state, commit }, {coachId, coacheeId}) => {
  return assignCoachCoachee(coachId, coacheeId).then(data => {
    return data
  })
}

export const loadSaveNote = ({ state, commit }, note) => {
  return saveNote(note).then(data => {
    return data
  })
}

export const loadNote = ({ state, commit }, {coacheeId, type}) => {
  return getNote(coacheeId, type).then(data => {
    return data
  })
}



// WEBPACK FOOTER //
// ./src/app/coacheeTracker/vuex/actions.js